import { FormBuilder, Validators } from '@angular/forms';
import { Examen } from '../Examen.config';
import { apellidoNombreTrabajadorValidator } from '../../../../../utils/apellido-nombre-trabajador-validator';

export class ExamenIluminacionInsuficiente extends Examen {
  id = 4;
  code = 'ILUMI';
  name = 'ESTUDIO ILUMINACIÓN INSUFICIENTE';
  baseUrl = 'estudios/carga';
  isAttachedFileRequire = false;
  sections = [
    {
      name: 'ESTUDIO ILUMINACIÓN INSUFICIENTE',
      fields: {
        fechaRealizacion: [ '', [ Validators.required ] ],
      },
    },
    {
      name: 'Empleador',
      fields: {},
      numberForm: 1,
    },
    {
      name: 'Trabajador',
      fields: {
        apellidoNombre:['', [Validators.required, Validators.maxLength(100), apellidoNombreTrabajadorValidator]],
        fechaNacimiento: ['', [Validators.required]],    
        puestoTrabajador: ['', [Validators.required]],
        fechaIngresoEmpresa: ['', [Validators.required]],
        antiguedadPuestoTrabajador: ['', [Validators.required]],
      },
      numberForm: 2,
    },
    {
      name: 'Antecedentes',
      fields: {
        antecedentesEnfermedad: [false],
        antecedentesEnfermedadSi: [false],
        antecedentesEnfermedadNo: [true],
        observacionesAntEnfermedad: [
          { value: '', disabled: true },
          [Validators.maxLength(1000)],
        ],
        antecedentesTrastornosCongenitos: [false],
        antecedentesTrastornosCongenitosSi: [false],
        antecedentesTrastornosCongenitosNo: [true],
        observacionesAntTrastornosCongenitos: [
          { value: '', disabled: true },
          [Validators.maxLength(1000)],
        ],
        antecedentesEnfermedadesProfesionales: [false],
        antecedentesEnfermedadesProfesionalesSi: [false],
        antecedentesEnfermedadesProfesionalesNo: [true],
        observacionesAntEnfermedadesProfesionales: [
          { value: '', disabled: true },
          [Validators.maxLength(1000)],
        ],
        antecedentesTrabajosAnteriores: [false],
        antecedentesTrabajosAnterioresSi: [false],
        antecedentesTrabajosAnterioresNo: [true],
        observacionesAntTrabajosAnteriores: [
          { value: '', disabled: true },
          [Validators.maxLength(1000)],
        ],
      },
      numberForm: 3,
    },
    {
      name: 'Estudio Clínico',
      fields: {
        cefaleas: [false],
        cefaleasSi: [false],
        cefaleasNo: [true],
        descripcionCefaleas: [
          { value: '', disabled: true },
          [Validators.maxLength(1000)],
        ],
        visionDoble: [false],
        visionDobleSi: [false],
        visionDobleNo: [true],
        descripcionVisionDoble: [
          { value: '', disabled: true },
          [Validators.maxLength(1000)],
        ],
        mareos: [false],
        mareosSi: [false],
        mareosNo: [true],
        descripcionMareos: [
          { value: '', disabled: true },
          [Validators.maxLength(1000)],
        ],
        conjuntivitis: [false],
        conjuntivitisSi: [false],
        conjuntivitisNo: [true],
        descripcionConjuntivitis: [
          { value: '', disabled: true },
          [Validators.maxLength(1000)],
        ],
        visionBorrosa: [false],
        visionBorrosaSi: [false],
        visionBorrosaNo: [true],
        descripcionVisionBorrosa: [
          { value: '', disabled: true },
          [Validators.maxLength(1000)],
        ],
      },
      numberForm: 4,
    },
    {
      name: 'Estudio Ocular',
      fields: {
        ojosCentrados: [true],
        ojosCentradosSi: [true],
        ojosCentradosNo: [false],
        conjuntivasNormal: [true],
        conjuntivasAnormal: [false],
        motilidadNormal: [true],
        motilidadAnormal: [false],
        fotosensibilidad: [false],
        fotosensibilidadSi: [false],
        fotosensibilidadNo: [true],
        pupilasNormal: [true],
        pupilasAnormal: [false],
        corneasNormal: [true],
        corneasAnormal: [false],        
        nistagmusNormal:[true],
        nistagmusAnormal:[false],
      },
      numberForm: 5,
    },
    {
      name: 'Agudeza Visual',
      fields: {
        ojoIzquierdoSinCorreccion: [ null, [ Validators.required, Validators.min( 0 ), Validators.max( 10 ) ] ],
        ojoIzquierdoConCorreccion: [ null, [ Validators.required, Validators.min( 0 ), Validators.max( 10 ) ] ],
        ojoDerechoSinCorreccion: [ null, [ Validators.required, Validators.min( 0 ), Validators.max( 10 ) ] ],
        ojoDerechoConCorreccion: [ null, [ Validators.required, Validators.min( 0 ), Validators.max( 10 ) ] ]
      },
      numberForm: 6,
    },
    {
      name: 'Dictamen medico',
      fields: {
        medicoNombre: [ '', [ Validators.required, Validators.pattern( /^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ\s]+$/ ), ] ],
        codigoDictamen: [ '', [ Validators.required ] ],
        matricula: ['', [Validators.required]],
        medicoEspecialidad: ['', [Validators.required]],
      },
      numberForm: 7,
    },
    {
      name: 'Adjuntos',
      fields: {},
      numberForm: 8,
    },
  ];

  constructor(formBuilder: FormBuilder) {
    super(formBuilder);
    this.fieldList = this.getFields();
    this.examForm = this.getForm();
    this.sectionsList = this.getSections();
  }

}
